module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [(_vm.flag === 'br') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))]) : (_vm.flag === 'de') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()))]), _vm._v(" "), (_vm.flag === 'br') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionPtbr))]) : (_vm.flag === 'de') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionDe))]) : (_vm.flag === 'us') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEn))]) : _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEs))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), (_vm.flag === 'br') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))]) : (_vm.flag === 'de') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Granmolino")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc3c150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 414
// module chunks = 1